export default {
    "noData": "Không có bản ghi nào",
    "EmptyData": "Chưa có dữ liệu",
    "search": "Tìm kiếm...",
    FeaturesIsDeveloping: "Tính năng đang phát triển",
    "command": {
        "add": "Thêm",
        "edit": "Sửa",
        "update": "Cập nhật",
        "delete": "Xóa",
        "deleteField": "Xóa thông tin",
        "duplicate": "Nhân bản",
        "more": "Thêm nữa...",
        "save": "Lưu",
        "saveNew": "Lưu & Thêm",
        "close": "Đóng",
        "hide": "Ẩn",
        "help": "Giúp",
        "cancel": "Hủy",
        "accept": "Đồng ý",
        "saveAndNew": "Lưu và thêm mới",
        "confirm": "Xác nhận",
        "notConfirm": "Không xác nhận",
        "export": "Xuất khẩu",
        "finish": "Hoàn thành",
        "load": "Nạp",
        "print": "In",
        "filter": "Lọc",
        "refresh": "Nạp",
        "setting": "Thiết lập",
        "default": "Mặc định",
        "list": "Danh sách",
        "addDetail": "Thêm dòng",
        "addDetailShortKey": "Thêm dòng (F9)",
        "import": "Nhập khẩu",
        "logout": "Đăng xuất",
        "next": "Tiếp theo",
        "cancel": "Hủy",
        "back": "Quay lại",
        "move": "Di chuyển",
    },
    List: {
        SearchEmptyText: "Tìm kiếm"
    },
    module: {
        employee: "Nhân viên"
    }
};
